<template>
  <div>
    <shck-lb />
  </div>
</template>

<script>
// 获取接口地址
import ShckLb from '@/components/shchuku/shck'

export default {
  name: 'Shck',
  components: {
    // sideMenu,
    // Header,
    ShckLb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
